/** Fuso civil usado nos prazos de ciclo — espelha `cycle-date.util.ts` no backend. */
const CYCLE_TZ = 'America/Sao_Paulo';

/** Dia do calendário (YYYY-MM-DD) do ISO da API, que vem ancorado ao meio-dia UTC. */
function calendarDayFromIso(iso: string): string | null {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Offset do fuso no dia informado (ex.: "-03:00"), resolvido pelo IANA em vez de fixado. */
function cycleTzOffset(calendarDay: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: CYCLE_TZ,
    timeZoneName: 'longOffset',
  }).formatToParts(new Date(`${calendarDay}T12:00:00Z`));
  const name = parts.find((p) => p.type === 'timeZoneName')?.value;
  return name ? name.replace('GMT', '') : '-03:00';
}

/**
 * Fim do dia (23:59:59.999 em America/Sao_Paulo) do calendário da data recebida.
 * Precisa bater com o backend, senão a UI libera envio que a API recusa (ou o contrário).
 */
export function endOfCalendarDayBrazilMs(iso: string): number {
  const day = calendarDayFromIso(iso);
  if (!day) return NaN;
  return new Date(`${day}T23:59:59.999${cycleTzOffset(day)}`).getTime();
}
